var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"danger","block":""},on:{"click":function($event){return _vm.$emit('back-step')}}},[_vm._v(" "+_vm._s(_vm.$t('buttons.back'))+" "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-chevron-left ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }